import { trackEvent } from '../../services/analytics';
import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Email, Google } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import TopAppBar from '../layout/TopAppBar';
import { PageContainer, SurfaceCard } from '../ui/ConvivialComponents';
import { signInWithGoogle, signInWithApple } from '../../services/firebaseData';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.redirectTo || '/';
    const { currentUser } = useAuth();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (currentUser) {
            navigate(redirectTo, { replace: true });
        }
    }, [currentUser, navigate, redirectTo]);

    const handleGoogleSignIn = async () => {
        setLoading(true);
        setError('');
        try {
            trackEvent('login_start', { method: 'google' });
            await signInWithGoogle();
        } catch (err) {
            trackEvent('login_error', { method: 'google' });
            console.error('Error during Google Sign In:', err);
            setError('Errore durante il login con Google. Riprova.');
            setLoading(false);
        }
    };

    const handleAppleSignIn = async () => {
        setLoading(true);
        setError('');
        try {
            trackEvent('login_start', { method: 'apple' });
            await signInWithApple();
        } catch (err) {
            trackEvent('login_error', { method: 'apple' });
            console.error('Error during Apple Sign In:', err);
            setError('Errore durante il login con Apple. Riprova.');
            setLoading(false);
        }
    };

    return (
        <>
            <TopAppBar title="ConvivialApp.it" variant="menu" showAvatar={false} />
            <PageContainer maxWidth="1080px" withBottomNav={false} sx={{ minHeight: 'calc(100dvh - var(--cv-top-bar-height))', display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.05fr 0.95fr' }, gap: { xs: 3, md: 5 }, alignItems: 'center' }}>

                    <Box
                        sx={{
                            // display: { xs: 'none', md: 'block' },
                            minHeight: 520,
                            borderRadius: 2,
                            overflow: 'hidden',
                            position: 'relative',
                            boxShadow: '0 18px 48px rgba(29,29,27,0.12)',
                            marginTop: 5,
                        }}
                    >
                        <Box
                            component="img"
                            alt="Networking dining table"
                            src="https://images.unsplash.com/photo-1519671282429-b44660ead0a7?auto=format&fit=crop&w=900&q=80"
                            sx={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }}
                        />
                        <Box sx={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(97,0,31,0.12), rgba(28,28,26,0.38))' }} />
                    </Box>

                    <Stack spacing={3.5} sx={{ width: '100%' }}>
                        <SurfaceCard sx={{ width: '100%' }}>
                            <Stack spacing={2.5}>
                                <>
                                    <Typography variant="h3" sx={{ fontSize: 22, textAlign: 'center' }}>Accedi a ConvivialApp.it</Typography>
                                    <Button variant="outlined" fullWidth startIcon={<Google />} onClick={handleGoogleSignIn} disabled={loading} sx={{ minHeight: 44, borderRadius: 2.5, borderColor: 'outline.main', color: 'text.primary', fontWeight: 600 }}>
                                        Google
                                    </Button>
                                    <Button variant="outlined" fullWidth startIcon={<Email />} onClick={handleAppleSignIn} disabled={loading} sx={{ minHeight: 44, borderRadius: 2.5, borderColor: 'outline.main', color: 'text.primary', fontWeight: 600 }}>
                                        Apple
                                    </Button>
                                </>

                                {error && <Typography color="error" variant="body2">{error}</Typography>}
                            </Stack>
                        </SurfaceCard>

                    </Stack>

                    <Typography variant="caption" sx={{ color: 'text.secondary', textAlign: 'left' }}>
                        Dopo l’accesso ti chiederemo di accettare i Termini e Condizioni e di prendere visione della Privacy Policy.
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary', textAlign: 'left' }}>
                        Se hai già un account, accederai automaticamente; altrimenti verrà creato un nuovo account associato al tuo indirizzo email Google.
                    </Typography>

                </Box>
            </PageContainer>
        </>
    );
}
